// Arma un link público de la tienda con la base del host (ver `storefrontBasePath` en
// lib/site/storefrontSeo.ts). MÓDULO PURO, sin imports de servidor: lo usan componentes de cliente.

/**
 * `base` es el prefijo del host (`""`, `/<slug>` o `/order/<slug>`); `subpath` va sin barra inicial
 * (`producto/<handle>`); `search` se agrega tal cual (`?carrito=1`). La raíz del dominio propio
 * (`base` y `subpath` vacíos) es `/`.
 */
export function storefrontHref(base: string, subpath: string, search = ""): string {
  const path = subpath ? `${base}/${subpath}` : base || "/"
  return `${path}${search}`
}

/**
 * Links de página de una grilla (pasillo, resultados de la búsqueda). Es un objeto y no una
 * función a propósito: la página (servidor) se lo pasa a `AisleGrid` (cliente), y React no deja
 * cruzar funciones a un componente de cliente. `query` va sin `?` y ya codificada (`q=leche`).
 */
export type PageLinks = { base: string; subpath: string; query?: string }

/** Link de la página `page` (desde 1): la 1 sin `pagina`, una sola URL canónica. */
export function pageLinkHref(links: PageLinks, page: number): string {
  const parts = [links.query ?? "", page > 1 ? `pagina=${page}` : ""].filter(Boolean)
  return storefrontHref(links.base, links.subpath, parts.length > 0 ? `?${parts.join("&")}` : "")
}

/** Parámetro de la portada de un local con platos y súper: `?seccion=mercado` abre la pestaña Mercado. */
export const SECCION_PARAM = "seccion"
export const SECCION_MERCADO = "mercado"

/**
 * Portada de la tienda abierta en la pestaña Mercado: la usan los links de vuelta de las
 * subpáginas del súper (pasillo, producto, /buscar, barra del carrito). `cart` abre el carrito
 * (`?carrito=1`) y convive con `seccion`. En un local que no es mixto el parámetro se ignora.
 * (No usa `urlWithSection`: `lib/microsite/storefrontKind.ts` ya importa este módulo.)
 */
export function storefrontHomeHref(base: string, opts: { cart?: boolean } = {}): string {
  const search = `${opts.cart ? "?carrito=1&" : "?"}${SECCION_PARAM}=${SECCION_MERCADO}`
  return storefrontHref(base, "", search)
}
